import { useEffect } from 'react';
export default (fn, deps) => {
    useEffect(() => {
        const controller = new AbortController();
        const timeouts = new Set();
        const intervals = new Set();
        const unsubscribes = new Set();
        fn({
            signal: controller.signal,
            async(callback) {
                callback();
            },
            timeout(ms, callback) {
                const id = setTimeout(callback, ms);
                timeouts.add(id);
                return id;
            },
            interval(ms, callback) {
                const id = setInterval(callback, ms);
                intervals.add(id);
                return id;
            },
            on(target, event, callback, options) {
                let unsubscribe;
                if ('on' in target) {
                    target.on(event, callback, options);
                    unsubscribe = () => target.off(event, callback);
                }
                else if ('addEventListener' in target) {
                    target.addEventListener(event, callback, options);
                    unsubscribe = () => target.removeEventListener(event, callback, options);
                }
                else if ('addListener' in target) {
                    target.addListener(event, callback, options);
                    unsubscribe = () => target.removeListener(event, callback);
                }
                else {
                    throw new Error('Invalid target, must have on/off or addEventListener/removeEventListener or addListener/removeListener');
                }
                unsubscribes.add(unsubscribe);
                return unsubscribe;
            }
        });
        return () => {
            controller.abort();
            timeouts.forEach(clearTimeout);
            intervals.forEach(clearInterval);
            unsubscribes.forEach(unsubscribe => unsubscribe());
        };
    }, deps);
};
